export default function TermsPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="mb-4 text-3xl font-bold text-white">Terms of Service</h1>
      <p className="mb-4 text-sm text-white/50">Last updated: March 2026</p>
      <div className="space-y-6 text-white/70">
        <p>By using Cascade, you agree to these terms. Cascade is a content automation platform that repurposes TikTok content for distribution across multiple social media platforms.</p>
        <h2 className="text-xl font-semibold text-white">Use of Service</h2>
        <p>You must be at least 18 years old to use Cascade. You are responsible for maintaining the security of your account and for all activity that occurs under your account.</p>
        <h2 className="text-xl font-semibold text-white">Content</h2>
        <p>You retain ownership of all content you submit to Cascade. By using the service, you grant Cascade a limited license to process and distribute your content on your behalf.</p>
        <h2 className="text-xl font-semibold text-white">Prohibited Use</h2>
        <p>You may not use Cascade to distribute illegal, harmful, or infringing content. We reserve the right to suspend accounts that violate these terms.</p>
        <h2 className="text-xl font-semibold text-white">Contact</h2>
        <p>For questions about these terms, contact us at support@pix3l.co.</p>
      </div>
    </div>
  );
}
